module.exports = __webpack_public_path__ + "static/img/role_ani.125d7cf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/mid-autumn/role_ani.gif
// module id = nMjr
// module chunks = 1